import { LoginResponse } from '@shared/api/rest/auth';
import { create } from 'zustand';

interface initialStateType {
  requireDUO: boolean;
  isAuthorized: boolean;
  token: string | null;
  waiting: boolean;
  status: number | null;
  isTCAccepted: boolean;
}
interface AuthState {
  requireDUO: boolean;
  isAuthorized: boolean;
  token: string | null;
  waiting: boolean;
  status: number | null;
  isTCAccepted: boolean;
  authSuccess: (payload: LoginResponse) => void;
  clearAuthState: () => void;
}

const initialState: initialStateType = {
  requireDUO: false,
  isAuthorized: false,
  token: null,
  waiting: false,
  status: null,
  isTCAccepted: false,
};

export const useAuthStore = create<AuthState>((set) => ({
  ...initialState,

  authSuccess: (payload) =>
    set(() => ({
      requireDUO: payload.status === 'auth',
      isAuthorized: payload.status === 'allow',
      token: payload.token,
      isTCAccepted: !!payload.is_tc_accepted,
    })),

  clearAuthState: () =>
    set((state) => ({
      ...state,
      requireDUO: false,
      tempToken: null,
      waiting: false,
      status: null,
    })),
}));
